(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["airosa-popup"] && !Shopify.designMode) return;
  try {
    class AirosaPopup extends HTMLElement {
    connectedCallback() {
      this.backdrop = this.querySelector('[ref="backdrop"]');
      this.closeButton = this.querySelector('[ref="closeButton"]');
      this.storageKey = 'airosaPopupDismissed';
      this.hasSuccess = this.querySelector('.airosa-popup__success') !== null;

      this.closeButton.addEventListener('click', () => this.close());
      this.backdrop.addEventListener('click', () => this.close());
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });

      if (this.hasSuccess) {
        this.open();
        return;
      }

      if (window.localStorage.getItem(this.storageKey)) return;
      if (window.Shopify && window.Shopify.designMode) return;

      const delay = parseInt(this.dataset.delay, 10) || 4000;
      setTimeout(() => this.open(), delay);
    }

    open() {
      this.setAttribute('open', '');
    }

    close() {
      this.removeAttribute('open');
      window.localStorage.setItem(this.storageKey, '1');
    }
  }

  customElements.define('airosa-popup', AirosaPopup);
  } catch(e) { console.error(e); }
})();

})();
